import { EnteteEcran } from '../components/ui/Primitives';
import { PilotageFinanceurs } from '../components/financements/PilotageFinanceurs';

/**
 * Pilotage des financeurs (phase 5, TF-489) : l'onglet « Pilotage par
 * financeur » de « Financeurs & OPCO » (TF-428) dans l'espace de la direction,
 * en consultation — pour chaque financeur, ses dossiers, ses références DK, ce
 * qu'il a pris en charge, ce qui est facturé, encaissé et reste dû, ses
 * retards ; filtres par antenne et export Excel.
 *
 * Même composant et même API que le pôle facturation : rien n'y est recopié.
 * L'écran ne porte aucune écriture ; le bloc Financement et les fiches des
 * financeurs restent dans « Financeurs & OPCO ».
 */
export function DirPilotageFinanceursPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-[1500px] space-y-6 p-4 sm:p-6">
      <EnteteEcran
        titre="Pilotage des financeurs"
        sousTitre="Dossiers, références de prise en charge, montants facturés, encaissés et reste dû par financeur et OPCO"
      />
      <PilotageFinanceurs />
    </div>
  );
}
